import React, { useState, useEffect } from "react";
import axios from "axios";

import { getUser, getIdToken } from "../../../utils/storage";
import {
  getResponses,
  getSurveyQuestionsAndRespondents,
} from "../../../services/dashboard-api";

const ResponsesTotal = (props) => {
  const { client, setToast, tooltip, setTooltip, newAllSurveysList } = props;

  const user = getUser(),
    idToken = getIdToken();

  const [totalResponses, setTotalResponses] = useState(0);

  // useEffect(() => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_API_BASE_URL}/versus_v2_get_total_responses`,
  //       {
  //         clientRef: client.clientRef,
  //         uid: user.uid,
  //         idToken,
  //       },
  //       { headers: { "content-type": "application/json" } }
  //     )
  //     .then((result) => {
  //       if (result.status === 200) {
  //         const total = result.data.totalResponses;
  //         setTotalResponses(total);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("Error obtaining total responses", error.message);
  //       setToast({
  //         show: true,
  //         type: "warning",
  //         message: "We had problems retrieving total responses. Please refresh",
  //       });
  //     });
  // }, [client.clientRef, idToken, setToast, user.uid]);

  useEffect(() => {
    const getSurveyQuestionsTotal = async () => {
      try {
        const campaignsRefs = newAllSurveysList?.map(
          (campaign) => campaign.campaignRef
        );

        const { data } = await getSurveyQuestionsAndRespondents(campaignsRefs);

        const counts = data?.surveysQuestionsAndRespondentsCounts || [];

        const totalRespondents = counts.reduce(
          (total, campaign) => total + campaign.totalRespondents,
          0
        );

        setTotalResponses(totalRespondents);
      } catch (error) {
        console.log(
          "Error obtaining total surveys questions and respondents.",
          error.response?.data || error.message
        );
      }
    };

    getSurveyQuestionsTotal();
  }, [newAllSurveysList]);

  return (
    <div className="card-section padded expand">
      <div className="data huge">{totalResponses}</div>
      <h3 className="move-down">Responses</h3>
      <div
        style={{
          display: tooltip.step === 3 ? "flex" : "none",
          width: "300px",
        }}
        className=" inline-tooltip-content top"
      >
        {/* step 3 tool tip */}
        <div className="card-section">
          <div>Responses</div>
          <p className="move-down">
            This is the total number of responses that have been received from
            all surveys that have been sent
          </p>

          <div className="inline-tooltip-frame">
            <span
              onClick={() =>
                setTooltip({
                  show: false,
                  type: "",
                  title: "",
                  message: "",
                  step: 0,
                  max_step: 5,
                })
              }
            >
              Skip tutorial
            </span>
            <button
              className="inline-tooltip-button"
              onClick={() =>
                setTooltip({
                  show: true,
                  type: "",
                  title: "",
                  message: "",
                  step: 4,
                  max_step: 5,
                })
              }
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsesTotal;
